export type ModerationCategory = 'chat' | 'saludo' | 'comentario' | 'concurso' | 'evento';
export type ModerationStatus = 'aprobado' | 'pendiente' | 'oculto' | 'bloqueado';

export interface ModerationItem {
  id: number;
  category: ModerationCategory;
  status: ModerationStatus;
  content: string;
  authorName: string;
  radioName: string;
  radioFrequency: string;
  date: string;
  reportedBy: string | null;
  reportReason: string | null;
  reportCount: number;
}

export const moderationItems: ModerationItem[] = [
  {
    id: 1,
    category: 'chat',
    status: 'pendiente',
    content: 'Alguien sabe a qué hora empieza el programa de la tarde? Estoy buscando esa info desde hace rato y no la encuentro en la app.',
    authorName: 'Marco Luján',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    date: '2026-06-17',
    reportedBy: 'Sistema',
    reportReason: 'Spam detectado',
    reportCount: 3,
  },
  {
    id: 2,
    category: 'chat',
    status: 'pendiente',
    content: 'Vendo iPhone 14 PRO MAX 256gb sellado garantía de fábrica. Interesados DM. ENVÍO GRATIS.',
    authorName: 'ventas_cel_2026',
    radioName: 'Radio Industria',
    radioFrequency: '93.5 FM',
    date: '2026-06-17',
    reportedBy: 'María G.',
    reportReason: 'Contenido comercial no autorizado',
    reportCount: 7,
  },
  {
    id: 3,
    category: 'saludo',
    status: 'pendiente',
    content: 'Un saludo enorme para toda la gente linda de La Matanza! Aguante el rock nacional vieja, no me importa nada!',
    authorName: 'El Pela Romero',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    date: '2026-06-17',
    reportedBy: null,
    reportReason: null,
    reportCount: 1,
  },
  {
    id: 4,
    category: 'saludo',
    status: 'aprobado',
    content: 'Buenos días Radio Éxito! Saludando desde Medellín, Colombia. Un abrazo para todos los oyentes de la 98.5!',
    authorName: 'Catalina Restrepo',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    date: '2026-06-17',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 5,
    category: 'comentario',
    status: 'pendiente',
    content: 'Este programa es una basura total. Los locutores no saben nada de música. Deberían cerrar esta radio de una vez.',
    authorName: 'usuario_anon123',
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    date: '2026-06-17',
    reportedBy: 'Locutor Juan Pablo',
    reportReason: 'Lenguaje ofensivo y difamatorio',
    reportCount: 5,
  },
  {
    id: 6,
    category: 'comentario',
    status: 'pendiente',
    content: 'Excelente programa de hoy! Me encantó la entrevista con el invitado. Sigan así, son los mejores de la radio.',
    authorName: 'Fernanda Castillo',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    date: '2026-06-17',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 7,
    category: 'concurso',
    status: 'pendiente',
    content: 'Mi respuesta para el concurso de entradas es: LOS BEATLES - ABBEY ROAD. Mi nombre es Pedro Gutiérrez, teléfono 5555-1234.',
    authorName: 'Pedro Gutiérrez',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    date: '2026-06-17',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 8,
    category: 'concurso',
    status: 'pendiente',
    content: 'Respuesta ganadora: ABBEY ROAD - THE BEATLES! Yo participo como Pedro Gutiérrez pero desde otra cuenta porque me bloquearon. Tel: 5555-9999.',
    authorName: 'PedroG_Oficial',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    date: '2026-06-17',
    reportedBy: 'Sistema',
    reportReason: 'Participación duplicada sospechosa',
    reportCount: 2,
  },
  {
    id: 9,
    category: 'evento',
    status: 'pendiente',
    content: 'Vamos a organizar una meetup de oyentes en el Parque Central este sábado a las 4pm. Traigan equipo de sonido y bebidas!',
    authorName: 'RadioFan Club Oficial',
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    date: '2026-06-17',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 10,
    category: 'chat',
    status: 'aprobado',
    content: 'Qué buena la canción que acaban de poner! Alguien sabe cómo se llama? Me suena muchísimo.',
    authorName: 'Luciana Torres',
    radioName: 'Radio Costa Azul',
    radioFrequency: '88.7 FM',
    date: '2026-06-17',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 11,
    category: 'chat',
    status: 'bloqueado',
    content: 'ESTA RADIO ES UNA ESTAFA. NO ENTREN A SU LINK DE DONACIONES. SON UNOS LADRONES.',
    authorName: 'denunciante_ok',
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    date: '2026-06-16',
    reportedBy: 'Admin Radio Peninsular',
    reportReason: 'Difamación y acusaciones falsas',
    reportCount: 3,
  },
  {
    id: 12,
    category: 'saludo',
    status: 'oculto',
    content: 'Saludos a mi ex que seguro me está escuchando. Ojalá te vaya bien. O no, la verdad no sé. En fin, la vida sigue.',
    authorName: 'Corazón Roto',
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    date: '2026-06-16',
    reportedBy: 'Oyente anónimo',
    reportReason: 'Contenido personal inapropiado',
    reportCount: 2,
  },
  {
    id: 13,
    category: 'comentario',
    status: 'bloqueado',
    content: 'Links de apuestas deportivas gratis: https://bit.ly/apuestas-seguras-2026 Gana dinero fácil sin invertir!',
    authorName: 'apuestas_win',
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    date: '2026-06-16',
    reportedBy: 'Sistema',
    reportReason: 'Spam y contenido malicioso',
    reportCount: 9,
  },
  {
    id: 14,
    category: 'concurso',
    status: 'aprobado',
    content: 'Respuesta concurso: Shakira - Monotonía. Participo: Andrea Márquez. Tel: 3333-5678.',
    authorName: 'Andrea Márquez',
    radioName: 'Nueva Actitud',
    radioFrequency: '107.5 FM',
    date: '2026-06-16',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 15,
    category: 'evento',
    status: 'bloqueado',
    content: 'Fiesta privada en mi casa este viernes. Dirección: Calle Falsa 123. Entrada gratis para chicas. Chicos $200.',
    authorName: 'party_king_2026',
    radioName: 'Éxitos TV',
    radioFrequency: '104.3 FM',
    date: '2026-06-16',
    reportedBy: 'Comunidad',
    reportReason: 'Evento no autorizado y posible estafa',
    reportCount: 6,
  },
  {
    id: 16,
    category: 'saludo',
    status: 'pendiente',
    content: 'Buenas noches desde Santiago de Chile! Escuchando la radio mientras estudio para el examen de mañana. Saludos a todos los trasnochadores!',
    authorName: 'Javiera Molina',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    date: '2026-06-16',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 17,
    category: 'chat',
    status: 'pendiente',
    content: 'Alguien tiene el link del stream? En la app no me carga y ya van 10 minutos sin poder escuchar nada.',
    authorName: 'Carlos Rivera',
    radioName: 'Stereo Visión',
    radioFrequency: '96.3 FM',
    date: '2026-06-16',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 18,
    category: 'comentario',
    status: 'oculto',
    content: 'La voz de la locutora es insoportable. No sé cómo la contrataron. Prefiero mil veces el programa anterior.',
    authorName: 'crítico_radio',
    radioName: 'Nueva Actitud',
    radioFrequency: '107.5 FM',
    date: '2026-06-16',
    reportedBy: 'Locutora Daniela',
    reportReason: 'Ataque personal a locutora',
    reportCount: 4,
  },
  {
    id: 19,
    category: 'concurso',
    status: 'pendiente',
    content: 'Concurso: Respuesta correcta es Coldplay - Yellow. Mi nombre: Tomás Jiménez. Tel 4444-7890. Soy el ganador seguro!',
    authorName: 'Tomás Jiménez',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    date: '2026-06-16',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 20,
    category: 'evento',
    status: 'aprobado',
    content: 'Concierto benéfico Pro Niñez este domingo en el Auditorio Nacional. Entradas disponibles en taquilla. Todo lo recaudado va a la fundación.',
    authorName: 'Fundación Esperanza',
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    date: '2026-06-15',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 21,
    category: 'chat',
    status: 'oculto',
    content: 'POR QUÉ NADIE ME RESPONDE??? Hola? HOLA??? Que radio de mentira, puros bots en el chat.',
    authorName: 'ignorado_siempre',
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    date: '2026-06-15',
    reportedBy: 'Moderador',
    reportReason: 'Comportamiento agresivo en chat',
    reportCount: 2,
  },
  {
    id: 22,
    category: 'saludo',
    status: 'aprobado',
    content: 'Saludos a mi familia en Buenos Aires! Los extraño muchísimo. Estoy escuchando desde Madrid y me siento más cerca de casa.',
    authorName: 'Martín Álvarez',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    date: '2026-06-15',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 23,
    category: 'comentario',
    status: 'aprobado',
    content: 'Me encanta la nueva programación! Los podcast de historia que están haciendo son increíbles. Aprendo algo nuevo cada día.',
    authorName: 'Diana Rojas',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    date: '2026-06-15',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 24,
    category: 'evento',
    status: 'pendiente',
    content: 'Torneo de FIFA 2026 entre oyentes de la radio. Inscripciones abiertas escribiendo al DM. Premio de $500 para el ganador!',
    authorName: 'GamerRadio Club',
    radioName: 'Éxitos TV',
    radioFrequency: '104.3 FM',
    date: '2026-06-15',
    reportedBy: null,
    reportReason: null,
    reportCount: 0,
  },
  {
    id: 25,
    category: 'concurso',
    status: 'bloqueado',
    content: 'GANADOR CONCURSO: Yo ya gané. El premio es mío. No acepto otra respuesta. Tel: 6666-0000. MANDEN EL PREMIO YA.',
    authorName: 'ganador_falso',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    date: '2026-06-14',
    reportedBy: 'Sistema',
    reportReason: 'Comportamiento agresivo e intimidante',
    reportCount: 5,
  },
];

export const moderationMetrics = {
  totalItems: 25,
  totalPending: 10,
  totalApproved: 6,
  totalHidden: 4,
  totalBlocked: 5,
  totalReported: 12,
  byCategory: {
    chat: { total: 6, pending: 3, approved: 1, hidden: 1, blocked: 1 },
    saludo: { total: 5, pending: 2, approved: 2, hidden: 1, blocked: 0 },
    comentario: { total: 5, pending: 2, approved: 1, hidden: 1, blocked: 1 },
    concurso: { total: 5, pending: 3, approved: 1, hidden: 0, blocked: 1 },
    evento: { total: 4, pending: 2, approved: 1, hidden: 0, blocked: 1 },
  },
};